export default __webpack_public_path__ + "static/media/demo-7.54cf46a3.png";